import React from "react";
import styled from "styled-components";
import { ReactComponent as SearchIcon } from "../../assets/Icons/search.svg";

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #1c1c1c66;
  padding: 4px;
  border-radius: 30px;
  width: ${(props) => (props.width ? props.width : "100%")};
  max-width: 400px;

  @media (max-width: 1400px) {
    width: 100%;
    max-width: 100%;
  }
`;

const StyledInput = styled.input`
  border: none;
  outline: none;
  width: 90%;
  padding: 8px;
  font-size: 16px;
  color: #1c1c1c66;

  &::placeholder {
    color: #1c1c1c66;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-right: 8px;
  color: #1c1c1c66;
  svg {
    width: 30px;
    height: 30px;
  }
`;

export function SearchInput({ placeholder, onChange, width, onClick, value }) {
  return (
    <InputWrapper width={width}>
      <StyledInput
        type="text"
        placeholder={placeholder || "Search..."}
        onChange={onChange}
        value={value}
      />
      <IconWrapper>
        <SearchIcon onClick={() => onClick()} />
      </IconWrapper>
    </InputWrapper>
  );
}

const InputElement = styled.input`
  border: none;
  outline: none;
  width: ${(props) => (props.width ? props.width : "90%")};
  padding: 8px 15px 8px 15px;
  font-size: 16px;
  color: #1c1c1c66;
  background-color:#D9D9D966;
  border-radius: 20px;
  margin: 10px 0px 10px 0px;

  &::placeholder {
    color: #1c1c1c66;
  }
`;

export function SimpleTextInput({ width, placeholder, type, onChange, value }) {
  return (
    <>
      <InputElement width={width}
        placeholder={placeholder}
        type={type}
        value={value}
        onChange={onChange} />
    </>
  );
}
